module.exports = __webpack_public_path__ + "img/baiwuranda-poster.bfd9915a.jpg";